import {
    RecentChats_recentChats_participants,
    RecentChats_viewer,
} from '../__generated__/RecentChats';

export function getLastReadAtForChatViewer(
    participantList: RecentChats_recentChats_participants[],
    viewer: RecentChats_viewer
): string | null {
    const viewingParticipant = participantList.filter(
        (participant) => participant.user.id === viewer.id
    );
    return viewingParticipant[0].lastReadAt;
}
export default getLastReadAtForChatViewer;
